/**
 * @generated SignedSource<<f36482b301661099e35420712043fba5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicPageQuery$variables = {
  after?: string | null;
  applicationIds?: ReadonlyArray<string | null> | null;
  count?: number | null;
  entityId: string;
  opinionAndColumnArticleTypeIds?: ReadonlyArray<string | null> | null;
  sponsorArticleQueueName: string;
  superTopicQueueName: string;
};
export type topicPageQuery$data = {
  readonly topic: {
    readonly advertZone: string | null;
    readonly entityId: string;
    readonly sponsor: {
      readonly __typename: "Sponsor";
    } | null;
    readonly types: ReadonlyArray<string | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"topicContentListOpinion" | "topicContentListTopic" | "topicHeaderTopic" | "topicSeoTopic" | "topicTopicPageTopic">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"topicContentListTopicSuperTopicQueueQuery" | "topicSponsorArticlesQueueQuery">;
};
export type topicPageQuery = {
  response: topicPageQuery$data;
  variables: topicPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationIds"
},
v2 = {
  "defaultValue": 30,
  "kind": "LocalArgument",
  "name": "count"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "opinionAndColumnArticleTypeIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sponsorArticleQueueName"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "superTopicQueueName"
},
v7 = {
  "kind": "Variable",
  "name": "entityId",
  "variableName": "entityId"
},
v8 = [
  {
    "fields": [
      (v7/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "types",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "advertZone",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v14 = {
  "kind": "Variable",
  "name": "applicationIds",
  "variableName": "applicationIds"
},
v15 = [
  (v13/*: any*/),
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "count",
    "variableName": "count"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v22 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": {
    "direction": "DESC",
    "field": "PUBLISHED_DATE"
  }
},
v23 = [
  (v13/*: any*/),
  {
    "fields": [
      (v14/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v22/*: any*/)
],
v24 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isContent"
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    (v25/*: any*/),
    (v18/*: any*/),
    {
      "alias": "size1200x800",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "1200x800"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v20/*: any*/),
      "storageKey": "style(filter:{\"style\":\"1200x800\"})"
    },
    {
      "alias": "size768x768",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "768x768"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v20/*: any*/),
      "storageKey": "style(filter:{\"style\":\"768x768\"})"
    },
    {
      "alias": "size540x360",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "540x360"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v20/*: any*/),
      "storageKey": "style(filter:{\"style\":\"540x360\"})"
    },
    {
      "alias": "size80x80",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "80x80"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v20/*: any*/),
      "storageKey": "style(filter:{\"style\":\"80x80\"})"
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "json",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alternativeName",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v37 = [
  (v36/*: any*/)
],
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v37/*: any*/),
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v37/*: any*/),
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "homepageDescription",
  "plural": false,
  "selections": (v37/*: any*/),
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    (v17/*: any*/),
    (v35/*: any*/),
    (v38/*: any*/),
    (v39/*: any*/),
    (v40/*: any*/),
    (v16/*: any*/)
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v16/*: any*/)
  ],
  "storageKey": null
},
v44 = [
  (v9/*: any*/),
  (v16/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": "articleTypes",
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v44/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v48 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegment",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": (v44/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v46/*: any*/),
    (v47/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v49 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v44/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v41/*: any*/),
    (v16/*: any*/),
    (v30/*: any*/),
    (v17/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        (v17/*: any*/),
        (v18/*: any*/),
        (v21/*: any*/),
        (v16/*: any*/)
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v12/*: any*/),
        (v42/*: any*/),
        (v43/*: any*/),
        (v45/*: any*/),
        (v48/*: any*/),
        (v49/*: any*/)
      ],
      "type": "Base",
      "abstractKey": "__isBase"
    }
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v41/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v52 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "118x118"
    }
  }
],
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": "AUTHOR_IMAGE"
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": (v52/*: any*/),
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v20/*: any*/),
          "storageKey": "style(filter:{\"style\":\"118x118\"})"
        }
      ],
      "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v12/*: any*/),
        (v42/*: any*/),
        (v30/*: any*/),
        (v43/*: any*/),
        (v45/*: any*/),
        (v48/*: any*/),
        (v49/*: any*/)
      ],
      "type": "Base",
      "abstractKey": "__isBase"
    }
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "printHeadline",
  "storageKey": null
},
v56 = [
  (v9/*: any*/)
],
v57 = {
  "kind": "InlineFragment",
  "selections": [
    (v42/*: any*/),
    (v43/*: any*/),
    (v45/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SectionSegment",
          "kind": "LinkedField",
          "name": "sections",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Section",
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": (v56/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v46/*: any*/),
        (v47/*: any*/)
      ],
      "type": "Article",
      "abstractKey": null
    },
    (v49/*: any*/)
  ],
  "type": "Base",
  "abstractKey": "__isBase"
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVideoContent",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "tmpLiveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v16/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    }
  ],
  "type": "Video",
  "abstractKey": null
},
v63 = [
  "filter",
  "orderBy"
],
v64 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v65 = {
  "kind": "InlineFragment",
  "selections": [
    (v58/*: any*/),
    (v59/*: any*/),
    (v41/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleTypeSegment",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleType",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v9/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/),
            (v38/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v60/*: any*/),
    (v61/*: any*/),
    (v47/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v66 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "disableFollow",
    "storageKey": null
  }
],
v67 = [
  (v16/*: any*/)
],
v68 = {
  "kind": "InlineFragment",
  "selections": (v67/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v69 = {
  "kind": "InlineFragment",
  "selections": (v67/*: any*/),
  "type": "Gallery",
  "abstractKey": null
},
v70 = {
  "kind": "InlineFragment",
  "selections": (v67/*: any*/),
  "type": "Podcast",
  "abstractKey": null
},
v71 = {
  "kind": "InlineFragment",
  "selections": (v67/*: any*/),
  "type": "Recipe",
  "abstractKey": null
},
v72 = {
  "kind": "InlineFragment",
  "selections": (v67/*: any*/),
  "type": "Video",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "topicPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "Topic",
        "kind": "LinkedField",
        "name": "topic",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Sponsor",
            "kind": "LinkedField",
            "name": "sponsor",
            "plural": false,
            "selections": [
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": (v15/*: any*/),
            "kind": "FragmentSpread",
            "name": "topicContentListTopic"
          },
          {
            "args": (v15/*: any*/),
            "kind": "FragmentSpread",
            "name": "topicTopicPageTopic"
          },
          {
            "args": [
              (v14/*: any*/),
              {
                "kind": "Variable",
                "name": "opinionAndColumnArticleTypeIds",
                "variableName": "opinionAndColumnArticleTypeIds"
              }
            ],
            "kind": "FragmentSpread",
            "name": "topicContentListOpinion"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicHeaderTopic"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicSeoTopic"
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "superTopicQueueName",
            "variableName": "superTopicQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "topicContentListTopicSuperTopicQueueQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "sponsorArticleQueueName",
            "variableName": "sponsorArticleQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "topicSponsorArticlesQueueQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "topicPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "Topic",
        "kind": "LinkedField",
        "name": "topic",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Sponsor",
            "kind": "LinkedField",
            "name": "sponsor",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": "ContentConnection",
            "kind": "LinkedField",
            "name": "contents",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v9/*: any*/),
                      (v24/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v39/*: any*/),
                      (v53/*: any*/),
                      (v54/*: any*/),
                      (v55/*: any*/),
                      (v16/*: any*/),
                      (v57/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v58/*: any*/),
                          (v59/*: any*/),
                          (v41/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArticleTypeSegment",
                            "kind": "LinkedField",
                            "name": "types",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleType",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v9/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v38/*: any*/),
                                  (v42/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v47/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v62/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "filters": (v63/*: any*/),
            "handle": "connection",
            "key": "topicContentList__topic_contents",
            "kind": "LinkedHandle",
            "name": "contents"
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "filters": (v63/*: any*/),
            "handle": "connection",
            "key": "topicTopicPage__author_contents",
            "kind": "LinkedHandle",
            "name": "contents"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Newsletter",
            "kind": "LinkedField",
            "name": "relatedNewsletters",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v17/*: any*/),
              (v35/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/),
          {
            "alias": "latestOpinions",
            "args": [
              {
                "fields": [
                  (v14/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "articleTypeIds",
                    "variableName": "opinionAndColumnArticleTypeIds"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              },
              (v64/*: any*/),
              (v22/*: any*/)
            ],
            "concreteType": "ContentConnection",
            "kind": "LinkedField",
            "name": "contents",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v9/*: any*/),
                      (v24/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v39/*: any*/),
                      (v53/*: any*/),
                      (v54/*: any*/),
                      (v55/*: any*/),
                      (v16/*: any*/),
                      (v57/*: any*/),
                      (v65/*: any*/),
                      (v62/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TopicRelatedLink",
            "kind": "LinkedField",
            "name": "relatedLink",
            "plural": true,
            "selections": [
              (v25/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormattedValue",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "html",
                "storageKey": null
              },
              (v36/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "type": {
                    "values": [
                      "MOBILE_APP_IMAGE",
                      "BREAKOUT",
                      "BREAKOUT_SPONSOR"
                    ]
                  }
                }
              }
            ],
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "images",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              {
                "alias": "icon",
                "args": (v52/*: any*/),
                "concreteType": "ImageStyle",
                "kind": "LinkedField",
                "name": "style",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": "style(filter:{\"style\":\"118x118\"})"
              },
              {
                "alias": "breakout",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "style": "2000x792"
                    }
                  }
                ],
                "concreteType": "ImageStyle",
                "kind": "LinkedField",
                "name": "style",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": "style(filter:{\"style\":\"2000x792\"})"
              },
              {
                "alias": "breakoutSponsor",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "style": "1560x218"
                    }
                  }
                ],
                "concreteType": "ImageStyle",
                "kind": "LinkedField",
                "name": "style",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": "style(filter:{\"style\":\"1560x218\"})"
              }
            ],
            "storageKey": "images(filter:{\"type\":{\"values\":[\"MOBILE_APP_IMAGE\",\"BREAKOUT\",\"BREAKOUT_SPONSOR\"]}})"
          },
          (v17/*: any*/),
          (v42/*: any*/),
          (v30/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metaDescription",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v12/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v66/*: any*/),
                "type": "Author",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v66/*: any*/),
                "type": "Topic",
                "abstractKey": null
              }
            ],
            "type": "Base",
            "abstractKey": "__isBase"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "KeyValuePair",
                "kind": "LinkedField",
                "name": "metatags",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "DynamicMetaTags",
            "abstractKey": "__isDynamicMetaTags"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "superTopicQueue",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "superTopicQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v64/*: any*/)
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v26/*: any*/),
                          (v9/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v39/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v55/*: any*/),
                          (v57/*: any*/),
                          (v65/*: any*/),
                          (v62/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArticleTypeSegment",
                            "kind": "LinkedField",
                            "name": "types",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleType",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v42/*: any*/),
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v16/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v68/*: any*/),
                      (v69/*: any*/),
                      (v70/*: any*/),
                      (v71/*: any*/),
                      (v72/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:10)"
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "sponsorArticlesQueue",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "sponsorArticleQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              }
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v56/*: any*/),
                        "type": "Base",
                        "abstractKey": "__isBase"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v26/*: any*/),
                          (v9/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v39/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v55/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v42/*: any*/),
                              (v30/*: any*/),
                              (v43/*: any*/),
                              (v45/*: any*/),
                              (v48/*: any*/),
                              (v49/*: any*/)
                            ],
                            "type": "Base",
                            "abstractKey": "__isBase"
                          },
                          (v65/*: any*/),
                          (v62/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v68/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v67/*: any*/),
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v69/*: any*/),
                      (v70/*: any*/),
                      (v71/*: any*/),
                      (v72/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:20)"
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4d33c86b697a7afca21d3c6bf03e4127",
    "id": null,
    "metadata": {},
    "name": "topicPageQuery",
    "operationKind": "query",
    "text": "query topicPageQuery(\n  $entityId: String!\n  $superTopicQueueName: String!\n  $sponsorArticleQueueName: String!\n  $applicationIds: [String]\n  $opinionAndColumnArticleTypeIds: [String]\n  $after: String\n  $count: Int = 30\n) {\n  topic(filter: {entityId: $entityId}) {\n    entityId\n    types\n    advertZone\n    sponsor {\n      __typename\n      id\n    }\n    ...topicContentListTopic_3In6IJ\n    ...topicTopicPageTopic_3In6IJ\n    ...topicContentListOpinion_cgYJP\n    ...topicHeaderTopic\n    ...topicSeoTopic\n    id\n  }\n  ...topicContentListTopicSuperTopicQueueQuery_1LY7E3\n  ...topicSponsorArticlesQueueQuery_3wOIuE\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  name\n  types\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"118x118\"}) {\n      url\n    }\n  }\n}\n\nfragment authorNameAuthor on Author {\n  ...entityLink\n  name\n}\n\nfragment blockquoteLongReadContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment blockquoteQuoteGenericPostiesArticleContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment cardContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  urlAlias\n  ...articleCommentArticle\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentAuthorLinkContent on Content {\n  __isContent: __typename\n  authors {\n    name\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n}\n\nfragment contentCoverImageContent on Content {\n  __isContent: __typename\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n    size80x80: style(filter: {style: \"80x80\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentItemRenderContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...contentCoverImageContent\n  ...contentActionBarContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentHeadlineContent\n  ...contentPrintHeadlineContent\n  ...contentTopicLinkContent\n  ...contentLiveTagContent\n  ...contentAuthorLinkContent\n  ...primaryContentItemContent\n  ...secondaryContentItemContent\n  ...searchContentItemContent\n  ...opinionContentItemContent\n  ...cardContentItemContent\n  ...morningStudioContentItemContent\n  ...hooksUseContentSponsorContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n}\n\nfragment contentLiveTagContent on Content {\n  __isContent: __typename\n  ... on Article {\n    flattenTypeIds\n    tmpLiveArticle {\n      status\n      id\n    }\n  }\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sections {\n    value {\n      relatedNewsletters {\n        ...helpersMassageToNewsletterItemNewsletter\n        id\n      }\n      id\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentPrintHeadlineContent on Content {\n  __isContent: __typename\n  printHeadline\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteLongReadContent\n  ...blockquoteQuoteContent\n  ...blockquoteQuoteGenericPostiesArticleContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  summary {\n    text\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment contentTopicLinkSuperTopic on Topic {\n  ...topicCheckSuperTopic\n  urlAlias\n  relatedLink {\n    url\n  }\n}\n\nfragment entityFollowButtonBase on Base {\n  __isBase: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on Base {\n  __isBase: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ...helpersAppBarVariantArticle\n  ...helpersAppBarAdStatusBase\n}\n\nfragment helpersAppBarAdStatusBase on Base {\n  __isBase: __typename\n  ... on Section {\n    __typename\n    ...helpersStyleSectionContent\n  }\n}\n\nfragment helpersAppBarVariantArticle on Base {\n  __isBase: __typename\n  ...helpersArticleSections\n  ...helpersCheckIsLongReadArticle\n  ...helpersCheckIsMorningStudioArticle\n  ...helpersCheckIsPhotoEssayArticle\n  ...helpersStyleArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersArticleSections on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsLongReadArticle on Article {\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsMorningStudioArticle on Article {\n  sponsorType\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPhotoEssayArticle on Article {\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersStyleArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHelperContent\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n  }\n  flag\n  sections {\n    value {\n      name\n      id\n    }\n  }\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n  authors {\n    entityId\n    types\n    id\n  }\n  flag\n}\n\nfragment hooksUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment hooksUseDeepLinkTagsBase on Base {\n  __isBase: __typename\n  __typename\n  urlAlias\n  entityId\n}\n\nfragment hooksUseDynamicMetaTags on DynamicMetaTags {\n  __isDynamicMetaTags: __typename\n  metatags {\n    key\n    value\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment morningStudioContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n}\n\nfragment opinionContentItemContent on Content {\n  __isContent: __typename\n  ...hooksContentHelperContent\n  ...entityLink\n  authors {\n    entityId\n    ...authorAvatarAuthor\n    ...authorNameAuthor\n    id\n  }\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment primaryContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  urlAlias\n  publishedDate\n}\n\nfragment searchContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n}\n\nfragment secondaryContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment topicCheckSuperTopic on Topic {\n  types\n}\n\nfragment topicContentListOpinion_cgYJP on Topic {\n  latestOpinions: contents(first: 10, filter: {applicationIds: $applicationIds, articleTypeIds: $opinionAndColumnArticleTypeIds}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        entityId\n        ...contentItemRenderContent\n        id\n      }\n    }\n  }\n  entityId\n}\n\nfragment topicContentListTopicSuperTopicQueueQuery_1LY7E3 on Query {\n  topic(filter: {entityId: $entityId}) {\n    ...topicCheckSuperTopic\n    ...contentTopicLinkSuperTopic\n    id\n  }\n  superTopicQueue: queue(filter: {name: $superTopicQueueName}) {\n    items(first: 10) {\n      edges {\n        node {\n          __typename\n          ...contentItemRenderContent\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Article {\n            types {\n              value {\n                entityUuid\n                id\n              }\n            }\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on Gallery {\n            id\n          }\n          ... on Podcast {\n            id\n          }\n          ... on Recipe {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment topicContentListTopic_3In6IJ on Topic {\n  contents(after: $after, first: $count, filter: {applicationIds: $applicationIds}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        entityId\n        ...contentItemRenderContent\n        ... on Article {\n          types {\n            value {\n              entityUuid\n              id\n            }\n          }\n        }\n        id\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  relatedNewsletters {\n    entityId\n    name\n    alternativeName\n    summary {\n      text\n    }\n    homepageDescription {\n      text\n    }\n    id\n  }\n  entityId\n  advertZone\n  id\n}\n\nfragment topicHeaderRelatedLinksTopic on Topic {\n  relatedLink {\n    title\n    url\n  }\n}\n\nfragment topicHeaderTopic on Topic {\n  ...topicHeaderRelatedLinksTopic\n  ...entityFollowButtonBase\n  description {\n    html\n  }\n  images(filter: {type: {values: [MOBILE_APP_IMAGE, BREAKOUT, BREAKOUT_SPONSOR]}}) {\n    type\n    icon: style(filter: {style: \"118x118\"}) {\n      url\n    }\n    breakout: style(filter: {style: \"2000x792\"}) {\n      url\n    }\n    breakoutSponsor: style(filter: {style: \"1560x218\"}) {\n      url\n    }\n  }\n  name\n  sponsor {\n    ...sponsorTagSponsor\n    id\n  }\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n}\n\nfragment topicSeoTopic on Topic {\n  entityUuid\n  entityId\n  sponsor {\n    name\n    id\n  }\n  name\n  description {\n    text\n  }\n  urlAlias\n  metaDescription\n  ...hooksUseDeepLinkTagsBase\n  ...hooksUseDynamicMetaTags\n}\n\nfragment topicSponsorArticlesQueueQuery_3wOIuE on Query {\n  sponsorArticlesQueue: queue(filter: {name: $sponsorArticleQueueName}) {\n    items(first: 20) {\n      edges {\n        node {\n          __typename\n          ... on Base {\n            __isBase: __typename\n            entityId\n          }\n          ...contentItemRenderContent\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on Article {\n            id\n          }\n          ... on Gallery {\n            id\n          }\n          ... on Podcast {\n            id\n          }\n          ... on Recipe {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment topicTopicPageTopic_3In6IJ on Topic {\n  contents(after: $after, first: $count, filter: {applicationIds: $applicationIds}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      __typename\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n}\n"
  }
};
})();

(node as any).hash = "ec17ddfd96e2208d3edaf4ded5d2dc1e";

export default node;
